module.exports = __webpack_public_path__ + "img/快乐-选中.5714bd45.png";